<template>
  <Navigation />
  <div class="pb-5 bg-finger">
    <div class="container hero-spacer"></div>
    <div class="container-fluid" style="margin-bottom: -100px; position: relative; z-index: 10;">
      <div class="card py-4">
        <div class="card-body">
          <h3 class="fw-bold text-center">{{ $t('createTransaction.title') }}</h3>
          <p class="p-0 m-0 text-center">{{ $t('createTransaction.subtitle') }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid mb-5 pb-3 padding-tab-content">
    <div class="px-4">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="nama" :placeholder="$t('fullnameHint')" v-model="nama" />
        <label for="nama">{{ $t('fullname') }}</label>
      </div>
      <p class="text-danger">{{ errors.nama }}</p>
      <div class="form-floating mb-3">
        <input type="email" class="form-control" id="email" :placeholder="$t('emailHint')" v-model="email" />
        <label for="email">{{ $t('email') }}</label>
      </div>
      <p class="text-danger">{{ errors.email }}</p>
      <div class="form-floating mb-3">
        <input type="tel" class="form-control" id="phone" :placeholder="$t('phoneHint')" v-model="phone" />
        <label for="phone">{{ $t('phone') }}</label>
      </div>
      <p class="text-danger">{{ errors.phone }}</p>
      <div class="form-floating mb-3">
        <input type="date" class="form-control" id="tgl_lahir" :placeholder="$t('birthdateHint')" v-model="tgl_lahir" />
        <label for="tgl_lahir">{{ $t('birthdate') }}</label>
      </div>
      <p class="text-danger">{{ errors.tgl_lahir }}</p>

      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-link fw-bold text-decoration-none p-0 border-0" @click="clearForm">{{ $t('reset') }}</button>
        <button class="btn btn-primary rounded-pill btn-sm w-25 fw-bold" @click="submitForm">{{ $t('continue') }}</button>
      </div>
    </div>
  </div>
  <BottomNav />
</template>

<script>
import Navigation from '../components/Navigation'
import BottomNav from '../components/BottomNav'
import axios from 'axios'

export default {
  name: 'AddTransaction',
  components: { BottomNav, Navigation },
  data() {
    return {
      errors: {},
      nama: this.$store.getters.getUser.fullname,
      email: this.$store.getters.getUser.email,
      phone: this.$store.getters.getUser.phone_number,
      tgl_lahir: this.$store.getters.getUser.birthdate,
      package: '',
    }
  },
  mounted() {
    this.package = this.$store.getters.getPackage
  },
  methods: {
    clearForm() {
      this.nama = ''
      this.email = ''
      this.phone = ''
      this.tgl_lahir = ''
    },
    async submitForm() {
      this.errors['nama'] = this.nama.length < 1 ? this.$t('validation.minLength', { field: this.$t('fullname'), min: 1 }) : ''
      this.errors['email'] = this.email.length < 3 ? this.$t('validation.minLength', { field: this.$t('email'), min: 3 }) : ''
      this.errors['tgl_lahir'] = !this.tgl_lahir ? this.$t('validation.required', { field: this.$t('birthdate') }) : ''
      this.errors['phone'] = !this.phone ? this.$t('validation.required', { field: this.$t('phone') }) : ''

      if (
        !this.errors['nama'] &&
        !this.errors['email'] &&
        !this.errors['tgl_lahir'] &&
        !this.errors['phone']
      ) {
        let self = this

        const formData = {
          user_id: this.$store.getters.getUser.id,
          fullname: this.nama,
          email: this.email,
          birthdate: this.tgl_lahir,
          phone: this.phone,
          language_id: 'id',
          package_id: this.package.id,
          package_name: this.package.name,
          is_hr: false,
          due_date: null,
          total_price: this.package.total_price,
          voucher_code: this.package.voucher_code ?? '',
          counselor_code: this.package.counselor_name ?? '',
          consultation_type: this.package.consultation_type ?? '',
        }

        await axios
          .post('/api/create_transaction', formData)
          .then((response) => {
            console.log(response)
            let transaction_id = response.data.transaction_id
            self.$store.dispatch('setTransaction', transaction_id)
            self.$router.push({ name: 'Upload Finger' })
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style scoped>
.padding-tab-content {
  padding-top: 5.5em;
}

@media only screen and (min-width: 375px) {
  .padding-tab-content {
    padding-top: 4.5em;
  }
}
</style>
